/*
 * Onboarding stepper. Row of circle dots and rails. Pass `steps`
 * and the `active` step key.
 */
import React from 'react'
import Icon from './Icon'

function GpStepper({ steps, active }) {
    const activeIdx = steps.findIndex((s) => s.key === active)

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                maxWidth: 880,
                margin: '0 auto 32px',
                padding: '0 12px',
            }}
        >
            {steps.map((s, i) => {
                const done = i < activeIdx
                const cur = i === activeIdx
                const dotBg = done ? 'var(--gp-brand)' : 'var(--gp-card)'
                const dotBd = done
                    ? 'var(--gp-brand)'
                    : cur
                        ? 'var(--gp-brand)'
                        : 'var(--gp-hairline)'
                const dotFg = done
                    ? '#FFFFFF'
                    : cur
                        ? 'var(--gp-brand)'
                        : 'var(--gp-ink-mute)'
                const railBg = i < activeIdx ? 'var(--gp-brand)' : 'var(--gp-hairline)'
                return (
                    <React.Fragment key={s.key}>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                gap: 8,
                                minWidth: 80,
                            }}
                        >
                            <div
                                style={{
                                    width: 40,
                                    height: 40,
                                    borderRadius: '50%',
                                    background: dotBg,
                                    border: `1.5px solid ${dotBd}`,
                                    color: dotFg,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.2s ease',
                                    flexShrink: 0,
                                }}
                            >
                                {done ? (
                                    <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2.4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                ) : (
                                    <Icon name={s.icon} size={18} stroke={1.75} />
                                )}
                            </div>
                            <span
                                style={{
                                    font: cur ? 'var(--gp-body-med)' : 'var(--gp-caption)',
                                    color: cur ? 'var(--gp-ink)' : 'var(--gp-ink-mute)',
                                    letterSpacing: 0.2,
                                }}
                            >
                                {s.label}
                            </span>
                        </div>
                        {i < steps.length - 1 && (
                            <div
                                style={{
                                    flex: 1,
                                    height: 2,
                                    background: railBg,
                                    margin: '0 -12px',
                                    position: 'relative',
                                    top: -10,
                                    borderRadius: 2,
                                    transition: 'background 0.2s ease',
                                }}
                            />
                        )}
                    </React.Fragment>
                )
            })}
        </div>
    )
}

export default GpStepper
